import SuperCarersOperations from "logic/SuperCarersOperations";
import SegmentClient from "clients/SegmentClient";
import { MAX_CARER_SEARCH_DISTANCE, SC_POSTCODE } from "global/constants";
import { createStringFromArray } from "utils";

const getLiveinCarers = async postcode => {
  try {
    const carerResults = await SuperCarersOperations.checkPostcodeForCarers(
      postcode,
      MAX_CARER_SEARCH_DISTANCE,
      true
    );
    return carerResults;
  } catch (e) {
    throw new Error(e);
  }
};

const getCarerResults = async postcode => {
  let carerResults = await SuperCarersOperations.checkPostcodeForCarers(
    postcode
  );
  if (carerResults.carersTotal < window.POSTCODE_CARER_RESULTS_TOTAL) {
    carerResults = await getLiveinCarers(postcode);
  }
  return carerResults;
};

const validatePostcode = async postcode => {
  let postcodeDetail;
  let postcodeArea;
  const maxDistrictsToShow = 3;

  try {
    postcodeDetail = await SuperCarersOperations.getPostcodeDetail(postcode);

    const postcodeDistrictArray = Array.isArray(postcodeDetail.admin_district)
      ? postcodeDetail.admin_district
      : [postcodeDetail.admin_district];

    postcodeArea =
      postcodeDistrictArray.length > maxDistrictsToShow
        ? "your area"
        : createStringFromArray(postcodeDistrictArray);

    return {
      postcodeValid: true,
      postcodeArea,
      latitude: postcodeDetail.latitude,
      longitude: postcodeDetail.longitude
    };
  } catch (err) {
    // postcode is invalid, exit
    SegmentClient.trackEvent({
      event: "postcode search invalid",
      eventCategory: "pre-user activation",
      eventAction: "postcode search completed",
      eventLabel: "submit",
      postcode
    });

    return { postcodeValid: false, postcodeArea: null };
  }
};

const runSearch = async componentState => {
  let {
    carers,
    carersTotal,
    latitude,
    liveinOnly,
    longitude,
    postcode,
    postcodeArea,
    postcodeValid
  } = componentState;

  // validate if this is a real postcode and assign variables
  ({
    latitude,
    longitude,
    postcodeArea,
    postcodeValid
  } = await validatePostcode(postcode));

  if (!postcodeValid) {
    postcode = SC_POSTCODE;
  }

  // Assign carer variables and flag if we are showing general livein or area specific carers
  ({ carers, carersTotal, liveinOnly } = await getCarerResults(postcode));

  // If the postcode is valid then add marketing tracking
  if (postcodeValid) {
    SegmentClient.trackIdentity({ post_code: postcode });

    SegmentClient.trackEvent({
      event: "postcode search completed",
      eventCategory: "pre-user activation",
      eventAction: "postcode search completed",
      eventLabel: "submit",
      postcode,
      carersTotal
    });
  }

  return {
    carers,
    carersTotal,
    latitude,
    liveinOnly,
    loading: false,
    longitude,
    postcodeArea,
    postcodeValid
  };
};

export default {
  getLiveinCarers,
  getCarerResults,
  runSearch,
  validatePostcode
};
